import styled, { css } from 'styled-components';

// Import styles utilities
import { shadows, flex, customMinResponsive, size, globalContentPadding } from 'components/styles';

export const HeaderStyled = styled.header<{ isShadow: boolean }>`
	position: sticky;
	top: 0;
	z-index: 1000;
	background-color: ${({ theme }) => theme.header.bg};
	height: ${({ theme }) => theme.nav.height}rem;
	${({ isShadow }) => isShadow && shadows.base}
	${globalContentPadding()}

	${customMinResponsive(
		size.semi,
		css`
			position: relative;
		`
	)}
`;

export const Wrapper = styled.div`
	height: 100%;
	display: flex;
	position: relative;
	top: 0;
`;

export const Logo = styled.div`
	height: 100%;
	${flex()};

	${customMinResponsive(
		size.small,
		css`
			padding-right: 2rem;
		`
	)}

	${customMinResponsive(
		1600,
		css`
			padding-right: 3rem;
		`
	)}
`;

export const Image = styled.img`
	height: 1.4rem;
	margin-right: 1rem;

	${customMinResponsive(
		400,
		css`
			height: 2.2rem;
		`
	)}
`;
